import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/adrw/Development/cash-services/misk-web/docs/node_modules/@westegg/gatsby-theme-digital-garden/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "toc"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h1"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h1",
            "href": "#examples"
          }}>{`Examples`}</a><ol parentName="li" {...{
            "className": "toc-level toc-level-2"
          }}><li parentName="ol" {...{
              "className": "toc-item toc-item-h2"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h2",
                "href": "#tabs"
              }}>{`Tabs`}</a></li><li parentName="ol" {...{
              "className": "toc-item toc-item-h2"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h2",
                "href": "#data"
              }}>{`Data`}</a></li></ol></li></ol></nav>

    <h1 {...{
      "id": "examples"
    }}>{`Examples`}</h1>
    <h2 {...{
      "id": "tabs"
    }}>{`Tabs`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/misk-web/docs/examples/starter-basic"
        }}>{`starter-basic`}</a>{`: basic example tab used in `}<inlineCode parentName="li">{`$ miskweb new`}</inlineCode></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/misk-web/docs/examples/palette-exemplar"
        }}>{`palette-exemplar`}</a>{`: tab with more complex examples for forms, network requests, and router path parameters`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/misk-web/docs/examples/palette-lts"
        }}>{`palette-lts`}</a>{`: palette-exemplar but using deprecated `}<inlineCode parentName="li">{`@misk/simpleredux`}</inlineCode>{` APIs to ensure continued support of old APIs`}</li>
    </ul>
    <h2 {...{
      "id": "data"
    }}>{`Data`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/misk-web/docs/examples/data"
        }}>{`data`}</a>{`: mock data sets to develop against`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      